// The brand currently selected in the settings brand dropdown (?brand=<slug>).
// Spread into brand-scoped form submissions so saves target the right brand;
// absent → the backend falls back to the account's default brand.
export function activeBrandParam(): { brand?: string } {
  if (typeof window === 'undefined') return {}
  const slug = new URLSearchParams(window.location.search).get('brand')
  return slug ? { brand: slug } : {}
}
